import { faChevronRight } from '~/assets';
import { currencyParser } from '~/modules';
import {
  Content,
  ContentFooter,
  ContentHeader,
  IconComponent,
  IconWrapper,
  InstallmentNumber,
  InstallmentOption,
  InstallmentTotalValue,
  InstallmentTotalValueLabel,
  InstallmentValue,
  Wrapper,
} from './styles';

interface InstallmentsOptionsProps {
  simulationPlans: SimulationPlans[];
  onOptionSelected: (plan: SimulationPlans) => void;
}

const InstallmentsOptions = ({
  simulationPlans,
  onOptionSelected,
}: InstallmentsOptionsProps) => {
  return (
    <Wrapper>
      {simulationPlans.map((installment, index) => (
        <InstallmentOption
          key={installment.id}
          $isLast={index === simulationPlans.length - 1}
          $isFirst={index === 0}
          role="button"
          onClick={() => {
            onOptionSelected(installment);
          }}
        >
          <Content>
            <ContentHeader>
              <InstallmentNumber>
                {installment.numberOfInstallments}x&nbsp;
              </InstallmentNumber>
              <InstallmentValue>
                {currencyParser(installment.installmentAmount || '')}
              </InstallmentValue>
            </ContentHeader>
            <ContentFooter>
              <InstallmentTotalValueLabel>
                Valor total de&nbsp;
              </InstallmentTotalValueLabel>
              <InstallmentTotalValue>
                {currencyParser(installment.totalAmount || '')}
              </InstallmentTotalValue>
            </ContentFooter>
          </Content>
          <IconWrapper>
            <IconComponent icon={faChevronRight} />
          </IconWrapper>
        </InstallmentOption>
      ))}
    </Wrapper>
  );
};

export default InstallmentsOptions;
